/**
 * Zentrale Steuerung für das globale Chat-Widget.
 * Ermöglicht es jeder Seite (z. B. Kontakt), den Chat zuverlässig zu öffnen,
 * auch wenn das Widget lazy-geladen ist oder sich gerade im Ladezustand befindet.
 */

let openChatCallback: (() => void) | null = null;
let pendingOpen = false;

export function registerOpenChatCallback(cb: () => void) {
  openChatCallback = cb;
  if (pendingOpen) {
    pendingOpen = false;
    cb();
  }
}

export function unregisterOpenChatCallback(cb: () => void) {
  if (openChatCallback === cb) {
    openChatCallback = null;
  }
}

export function openBigFollowChat() {
  if (openChatCallback) {
    openChatCallback();
    return true;
  }
  pendingOpen = true;
  return false;
}

export function setOpenChatPending(value: boolean) {
  pendingOpen = value;
}
